import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NavigationService } from '../services/navigation.service';

@Injectable({ providedIn: 'root' })
export class SystemAdminGuard {
  constructor(private authService: AuthService, private navigationService: NavigationService) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (!this.authService.isSystemAdmin) {
      await this.navigationService.navigateToNotFound(true);
      return false;
    }

    return true;
  }
}
